export default "__VITE_ASSET__BBa4VUIh__"